import { css } from '@emotion/react';
import { ButtonLink } from '@/components/shared/ButtonLink';
import { PRIVACY_POLICY_URL } from '@/constants/url';
import { pagesPath } from '@/lib/pagesPath';
import { getScreen } from '@/styles/media-query';
import { Link, withPrefix } from 'gatsby';
import { AnchorLink } from 'gatsby-plugin-anchor-links';

export type HeroSectionProps = {
  className?: string;
};

export const HeroSection: React.FC<HeroSectionProps> = ({ className }) => {
  return (
    <section
      css={css`
        background: linear-gradient(
          180deg,
          #def6f5 0%,
          #f0fcfb 60%,
          #ffffff 100%
        );
        overflow: hidden;

        @media ${getScreen('pc')} {
          background: linear-gradient(
            130deg,
            #def6f5 0%,
            #f0fcfb 60%,
            #ffffff 100%
          );
          position: relative;
        }
      `}
      className={className}
    >
      <div
        css={css`
          position: absolute;
          top: 0;
          left: 0;
          padding: 24px 20px;
          z-index: 2;

          @media ${getScreen('pc-menu')} {
            display: none;
          }
        `}
      >
        <img
          css={css`
            width: 153px;

            @media ${getScreen('pc')} {
              width: 162px;
            }
          `}
          src={withPrefix('/images/logo.svg')}
          alt="Uniforce(ユニフォース) IPO準備クラウド"
          width="174"
          height="46"
          loading="lazy"
        />
      </div>
      <div
        css={css`
          position: absolute;
          top: 0;
          right: 0;
          padding: 24px 20px;
          z-index: 2;

          @media ${getScreen('pc-menu')} {
            display: none;
          }
        `}
      >
        <Link to="/#phaseinfo">
          <img
            src={withPrefix('/images/menu_phaseinfo.png')}
            alt="課題ツアー"
            height="46"
          />
        </Link>
      </div>
      <div
        css={css`
          position: absolute;
          top: 100px;
          left: 0px;
          right: 0px;
          z-index: 10;
          width: 100%;
          max-width: 1440px;
          margin: auto;
          
          @media ${getScreen('pc', '未満')} {
            top: -38px;
          }
        `}
      >
        <div
          css={css`
            position: absolute;
            right: 16px;
            z-index: 10;
            width: 140px;
            
            @media ${getScreen('pc', '未満')} {
              display: none;
            }
          `}
        >
          <img
            css={css`
              width: 100%;
            `}
            src={withPrefix('/images/logo_gd.png')}
            alt="GOOD DESIGN AWARD"
          />
        </div>
      </div>
      <div
        css={css`
          position: relative;
          padding-top: 40px;

          @media ${getScreen('pc')} {
            padding: 210px calc(calc(100% - 870px) * 0.123) 190px;
          }
        `}
      >
        <div
          css={css`
            position: relative;
            z-index: 1;
            max-width: 1344px;
            margin: 0 auto;
          `}
        >
          <div
            css={css`
              position: absolute;
              z-index: -1;
              top: -130px;
              left: calc(50% - 280px);
              transform: scale(1.05);

              @media ${getScreen('pc')} {
                top: -210px;
                left: -225px;
                transform: none;
              }
            `}
          >
            <img
              css={css`
                @media ${getScreen('pc')} {
                  display: none;
                }
              `}
              src={withPrefix('/images/kv-bg.png')}
              width="469"
              height="460"
              alt=""
              loading="lazy"
            />
            <img
              css={css`
                @media ${getScreen('pc', '未満')} {
                  display: none;
                }
              `}
              src={withPrefix('/images/kv-bg-pc.png')}
              width="937"
              height="740"
              alt=""
              loading="lazy"
            />
          </div>
          <div
            css={css`
              overflow: hidden;
              display: flex;
              justify-content: center;
              margin: -80px 0 -90px;

              @media ${getScreen('pc')} {
                display: none;
              }
            `}
          >
            <div
              css={css`
                width: 433px;
                height: 479px;
              `}
            >
              <img
                src={withPrefix('/images/kv.png')}
                width="433"
                height="479"
                alt=""
                loading="lazy"
              />
            </div>
          </div>
          <div
            css={css`
              width: 100%;
              height: 667px;
              position: absolute;
              top: -98px;
              left: 523px;
              overflow: hidden;
              pointer-events: none;

              @media ${getScreen('pc', '未満')} {
                display: none;
              }
            `}
          >
            <img
              src={withPrefix('/images/kv-pc.png')}
              width="999"
              height="670"
              alt=""
              loading="lazy"
            />
          </div>
          <div
            css={css`
              padding: 16px 30px 42px;

              @media ${getScreen('pc')} {
                margin: 0 auto;
                padding: 0 116px 0 126px;
              }
            `}
          >
            <p
              css={css`
                display: flex;
                justify-content: center;
                gap: 5px;
                align-items: flex-end;
                margin-bottom: 9px;
                font: normal normal bold 14px/21px 'Noto Sans JP', sans-serif;
                letter-spacing: 0.08em;
                color: #282b40;
                text-align: center;

                @media ${getScreen('pc')} {
                  font: normal normal bold 16px/18px 'Noto Sans JP', sans-serif;
                  letter-spacing: 1.44px;
                  color: #282b40;
                  text-align: left;
                  justify-content: flex-start;
                  margin-bottom: 10px;
                  gap: 10px;
                  padding: 0 20px;
                  height: 25px;
                }

                &::before,
                &::after {
                  content: '';
                  display: block;
                  width: 2px;
                  height: 28px;
                  background: #00b3a7;
                  border-radius: 9999px;
                  transform: rotate(-45deg);
                  transform-origin: right bottom;

                  @media ${getScreen('pc')} {
                    height: 28px;
                    transform: rotate(-45deg);
                  }
                }

                &::after {
                  transform: rotate(45deg);
                  transform-origin: left bottom;
                  
                  @media ${getScreen('pc')} {
                    transform: rotate(45deg);
                  }
                }
              `}
            >
              いつでも専門家に相談できるから安心
            </p>
            <h1
              css={css`
                margin-bottom: 37px;
                display: flex;
                flex-direction: column;
                gap: 1px;
                align-items: center;
                
                text-align: center;
                
                @media ${getScreen('pc')} {
                  align-items: flex-start;
                  gap: 20px;
                  margin-bottom: 40px;
                  text-align: left;
                }
              `}
            >
              <AnchorLink to="#wats"><span
                css={css`
                  font: normal normal bold 29px/40px 'Noto Sans JP', sans-serif;
                  letter-spacing: 0.008em;
                  color: #00b3a7;
                  text-align: center;
                  margin: -3px 0;

                  @media ${getScreen('pc')} {
                    font: normal normal bold 49px/62px 'Noto Sans JP',
                      sans-serif;
                    letter-spacing: 0px;
                    text-align: left;
                    margin: -5px 0;
                  }
                `}
              >
                <b
                  css={css`
                    font: normal normal bold 40px/40px 'Noto Sans JP', sans-serif;
                    @media ${getScreen('pc')} {
                      font: normal normal bold 71px/71px 'Noto Sans JP', sans-serif;
                    }
                  `}
                >上場まで</b>の
                <img
                  css={css`
                    position: relative;
                    width: 60px;
                    bottom: -7px;
                    
                    @media ${getScreen('pc')} {
                      width: 90px;
                      bottom: -5px;
                    }
                  `}
                  src={withPrefix('/images/kv-icon_ma.png')}
                  alt="M&Aにも対応"
                  loading="lazy"
                />
                <br />
                道のりを完全サポート
              </span></AnchorLink>
              <span
                css={css`
                  text-align: center;
                  font: normal normal bold 16px/21px 'Noto Sans JP', sans-serif;
                  letter-spacing: 0.02em;
                  color: #7d7d88;
                  margin-top: 11px;

                  @media ${getScreen('pc')} {
                    text-align: left;
                    font: normal normal 500 20px/30px 'Noto Sans JP',
                      sans-serif;
                    letter-spacing: 0.44px;
                    margin-top: 0;
                  }
                `}
              >
                その価値ある“挑戦“に追い風を！<br />
                「IPO準備クラウド」で経営基盤を強化
              </span>
            </h1>
            <div
              css={css`
                display: flex;
                flex-direction: column;
                gap: 16px;

                @media ${getScreen('pc')} {
                  flex-direction: row;
                  margin-bottom: 20px;
                }
              `}
            >
              <ButtonLink to={pagesPath.contact.$url()} variant="hero-demo">
                相談する
              </ButtonLink>
              <ButtonLink
                to={pagesPath.download.$url()}
                variant="hero-download"
              >
                資料請求
              </ButtonLink>
            </div>
          </div>
          <div
            css={css`
              position: absolute;
              bottom: -195px;
              left: 116px;

              @media ${getScreen('pc', '未満')} {
                display: none;
              }
            `}
          >
          </div>
        </div>
      </div>
    </section>
  );
};
